function init() {
	let imgs = document.querySelectorAll("[data-srcset]");

	function initAnimationThumb(elem) {
		let sources = elem.querySelectorAll("source");

		window.utils.forEach(sources, function (source_key, source) {
			let srcset = source.getAttribute("data-srcset");
			source.setAttribute("srcset", srcset);
			source.removeAttribute("data-srcset");
		});

		let parent = elem.parentElement,
			thumb = parent.querySelector(".thumb"),
			img = elem.querySelector("img");

		window.utils.isImageLoaded(img, function () {
			parent.classList.add("image-loaded");
			hideThumb(thumb);
		});
	}

	function startObserverLazy() {
		let lazyImageObserver = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting || entry.intersectionRatio > 0) {
						let lazyImage = entry.target;
						initAnimationThumb(lazyImage);
						lazyImageObserver.unobserve(lazyImage);
					}
				});
			},
			{
				rootMargin: "20% 0px 20% 0px",
				threshold: 0.5,
			}
		);

		window.utils.forEach(imgs, function (index, elem) {
			elem = elem.parentElement;
			lazyImageObserver.observe(elem);
		});
	}

	async function hideThumb(thumb) {
		if (!thumb) return;

		// legge la config da window.utils.imageSettings.thumbHide (se presente)
		const imageSettings = (window.utils && window.utils.imageSettings) || {};
		const cfg = imageSettings.thumbHide || {};

		const delay = Number.isFinite(Number(cfg.delay)) ? Number(cfg.delay) : 1000;
		const mode = (cfg.mode || "display-none").toLowerCase();

		// attende il delay configurabile
		await new Promise((resolve) => setTimeout(resolve, delay));

		if (mode === "opacity") {
			// usa la classe configurata o imposta inline style
			if (cfg.opacityClass) {
				thumb.classList.add(cfg.opacityClass);
			} else {
				thumb.style.opacity = "0";
			}
		} else {
			// default: display none tramite classe configurabile
			const displayNoneClass = cfg.displayNoneClass || "display-none";
			thumb.classList.add(displayNoneClass);
		}
	}

	if (imgs.length > 0) {
		startObserverLazy();
	}
}

export default { init };
